module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.43.54.d2c5d671.jpg";